import { useEffect, useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchBarProps {
  initialValue?: string;
  variant?: 'navbar' | 'page';
  placeholder?: string;
}

export default function SearchBar({
  initialValue = '',
  variant = 'navbar',
  placeholder = '搜索电影、电视剧、演员…',
}: SearchBarProps) {
  const [value, setValue] = useState(initialValue);
  const navigate = useNavigate();

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const keyword = value.trim();
    if (!keyword) return;
    navigate(`/search?q=${encodeURIComponent(keyword)}`);
  };

  const isPage = variant === 'page';

  return (
    <form
      onSubmit={handleSubmit}
      className={`flex w-full items-center rounded-full border bg-background-50 transition-colors focus-within:border-primary-400 ${
        isPage ? 'border-background-300 px-2 py-1.5' : 'border-background-200 px-1.5 py-1'
      }`}
      role="search"
    >
      <span className={`flex items-center justify-center text-foreground-400 ${isPage ? 'h-9 w-9' : 'h-8 w-8'}`}>
        <i className={`ri-search-line ${isPage ? 'text-lg' : 'text-base'}`}></i>
      </span>
      <input
        type="text"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        placeholder={placeholder}
        aria-label="搜索影视内容"
        className={`min-w-0 flex-1 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none ${
          isPage ? 'py-1.5' : 'py-1'
        }`}
      />
      <button
        type="submit"
        className={`ml-1 shrink-0 whitespace-nowrap rounded-full bg-accent-500 font-medium text-background-50 transition-colors hover:bg-accent-600 dark:text-foreground-950 ${
          isPage ? 'px-5 py-2 text-sm' : 'px-4 py-1.5 text-xs'
        }`}
      >
        搜索
      </button>
    </form>
  );
}